import type { PropsWithChildren, ReactNode } from 'react';
import React from 'react';

import styles from './Description.module.scss';

interface DescriptionProps {
	heading: ReactNode;
	infoText?: ReactNode;
	noteText?: ReactNode;
}

export const Description: React.FC<PropsWithChildren<DescriptionProps>> = ({ heading, infoText, noteText }) => {
	return (
		<div className={styles.container}>
			<h2 className={styles.headingText}>{heading}</h2>
			{infoText && <p className={styles.infoText}>{infoText}</p>}
			{noteText && <i className={styles.infoText}>{noteText}</i>}
		</div>
	);
};
